import React from "react";
import { Spinner } from "reactstrap";
import { useTable } from "react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import useMarketAnalysis from "../query/hooks/useMarketAnalysis";

const MarketAnalysisTable = ({ sponsorObjectId }) => {
  const { t } = useTranslation();
  const { data, isFetching } = useMarketAnalysis(sponsorObjectId);

  const columns = useMemo(() => data.headers, [data]);
  const dataRows = useMemo(() => data.rows, [data]);

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data: dataRows,
    });

  return (
    <>
      {isFetching && <Spinner color="primary" />}
      
      <div className="table-responsive">
        <table
          className="table table-hover table-centered table-nowrap mb-0 text-white"
          {...getTableProps()}
        >
          <thead>
            {headerGroups.map((headerGroup, index) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, columnIndex) => (
                  <th
                    key={columnIndex}
                    width={
                      columnIndex === 0 ? "25%" : 
                      columnIndex === 1 ? "20%" : 
                      columnIndex === 2 ? "20%" : 
                      columnIndex === 3 ? "20%" :
                      "15%"
                    }
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row, i) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()} key={i}>
                    {row.cells.map((cell, cellIndex) => {
                      return (
                        <td {...cell.getCellProps()} key={cellIndex}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={columns.length} className="text-center py-4">
                  <div className="text-muted">
                    <i className="mdi mdi-information-outline me-2"></i>
                    {t("No market data available for the selected period")}
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default MarketAnalysisTable;